import errorManager from '@/rollbar.js';
import apiConnector from '@/epersonam/apiConnector';

function init() {
  try {
    eventBus.$on('domesticPlannerGuestSelected', async (guest_id) => {
      const domesticActivitiesSelect = $('#guest_activity_domestic_activities_config_id');
      try {
        domesticActivitiesSelect.show();
        const url = document.getElementById('guest_activity_domestic_activities_config_id').getAttribute('data-url');
        const selectedOpt = domesticActivitiesSelect.select2('data')[0] || {};
        let selected_text = selectedOpt['description'] || domesticActivitiesSelect.find(':selected').text();
        if (selectedOpt['cod']) {
          selected_text += ' (' + selectedOpt['cod'] + ')';
        }
        const selectedValue = selectedOpt['id'];
        domesticActivitiesSelect.select2('destroy');
        const guestSelectedId = $('.select_domestic_guests_' + guest_id).val();
        const new_activities_url = url + '&guest_status_id=' + guestSelectedId;
        domesticActivitiesSelect.data('ajaxUrl', new_activities_url);
        window.bindSelect2Fields();
        const activitySearchTerm = selected_text.replace(/\s+\([^)]*\)$/, '');
        const verificationUrl = new_activities_url + '&term=' + encodeURIComponent(activitySearchTerm);
        const { data } = await apiConnector({ Accept: 'application/json' }).get(verificationUrl);
        if (data.length === 0) {
          domesticActivitiesSelect.select2('destroy');
          domesticActivitiesSelect.empty();
          window.bindSelect2Fields();
          const closestForm = domesticActivitiesSelect.closest('form');
          closestForm.find('.sub-activities-config-div').empty();
        } else {
          const defaultOption = new Option(selected_text, selectedValue, true, true);
          domesticActivitiesSelect.append(defaultOption);
        }
      } catch (exception) {
        errorManager(exception);
      }
    });

    const modal = document.querySelector('#openMonthlyLockModal');
    if (!modal) return;

    modal.addEventListener('click', () => {
      eventBus.$emit('domestic-planner-month-lock-modal-opened');
    });
  } catch (e) {
    errorManager(e);
  }
}

window.DomesticPlannerAgenda = {
  init: init,
};
